import { chakra } from "@chakra-ui/react";
import { replacePlaceholders } from "../layout/documentLayout";
import { firstAnswer, formatTextAnswer, isTextItemType, replaceInAnswer } from "./answerFormat";
import { TitledBlock } from "./printStyles";
import type { QuestionViewProps } from "./types";

// textShort, textLong, number, date, time, bloodPressure, weight -> the PDF's Text / StartEndTime
// blocks: title above a 2px underline, then the answer (unanswered prints blank).

const AnswerText = chakra("div", {
  baseStyle: {
    // Keeps an empty answer line visible instead of collapsing to nothing.
    minHeight: "1em",
    overflowWrap: "anywhere",
    whiteSpace: "pre-wrap",
  },
});

export function TextQuestionView({ block, placeholders }: QuestionViewProps) {
  const { question } = block;
  const itemType = isTextItemType(question.itemType) ? question.itemType : "textShort";
  const text = formatTextAnswer(
    itemType,
    replaceInAnswer(firstAnswer(block.answers), placeholders)
  );

  return (
    <TitledBlock
      gap="6px"
      isInline={question.answerInline === true}
      title={replacePlaceholders(question.label, placeholders)}
    >
      <AnswerText>{text}</AnswerText>
    </TitledBlock>
  );
}
